import api from '@/api/verification_questions';
import store from '@/store/store';

const fetchVerificationQuestions = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.fetchVerificationQuestions(criteria.criteriaCategoryId,criteria.limited,criteria.searchTerm,criteria.self_id)
      .then((response) => {
        resolve(response);
        if(self_id !== undefined) {
          store.commit('verificationQuestions/storeVerificationQuestionList', response);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const createVerificationQuestion = (context, params) => {
  return new Promise(((resolve, reject) => {
    api.createVerificationQuestion(params)
      .then((response) => {
        resolve(response);
        store.commit('verificationQuestions/storeCreatedVerificationQuestion', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const createVerificationQuestionForSubCategory = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.createVerificationQuestionForSubCategory(criteria.params,criteria.categoryId)
      .then((response) => {
        resolve(response);
        store.commit('verificationQuestions/storeCreatedVerificationQuestion', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const fetchVerificationQuestion = (context, id) => {
  return new Promise(((resolve, reject) => {
    api.fetchVerificationQuestion(id)
      .then((response) => {
        resolve(response);
        store.commit('verificationQuestions/storeVerificationQuestion', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const fetchVerificationQuestionWithCategoryId = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.fetchVerificationQuestionWithCategoryId(criteria.id,criteria.categoryId)
      .then((response) => {
        resolve(response);1
        store.commit('verificationQuestions/storeVerificationQuestion', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

const updateVerificationQuestion = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.updateVerificationQuestion(criteria.id,criteria.params)
      .then((response) => {
        resolve(response);
        store.commit('verificationQuestions/storeUpdatedVerificationQuestion', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const deleteVerificationQuestion = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.deleteVerificationQuestion(criteria.id,criteria.categoryId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const searchVerificationQuestions = (context, criteria) => {
  return new Promise(((resolve, reject) => {
    api.searchVerificationQuestions(criteria)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        reject(error);
      });
  }));
};

export default {
  fetchVerificationQuestions,
  createVerificationQuestion,
  fetchVerificationQuestion,
  updateVerificationQuestion,
  deleteVerificationQuestion,
  searchVerificationQuestions,
  createVerificationQuestionForSubCategory,
  fetchVerificationQuestionWithCategoryId
};




// WEBPACK FOOTER //
// ./src/store/modules/verification_questions/actions.js